define('views/pages/multi-account/summary',['require','views/base/view','text!templates/pages/multi-account/summary.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        template = require('text!templates/pages/multi-account/summary.ejs');

    var SummaryView = View.extend({
        autoRender: true,
        template: template,
        region: 'accounts-summary',
        className: 'accounts-summary',
        listen: {
            'change model': 'render'
        },

        initialize: function () {
            View.prototype.initialize.apply(this, arguments);

            this.listenTo(this.model.get('params'), 'change:currencyCode', this.render);
        },
    });

    return SummaryView;
});

